import React, {useEffect} from "react";
export const Philosophy: React.VFC = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return(
		<div className="mx-auto">
			<div className="w-[100%] h-[250px] m-auto text-center bg-cover bg-center bg-[url('./assets/vdaon04-2-1024x683.jpeg')]">
				<div className="flex h-[250px] bg-black opacity-70">
					<span className="m-auto text-white font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl">経営理念</span>
				</div>
			</div>
			<div className="text-gray-500 text-xl mt-10 m-auto w-[75%]">
				<div className="italic text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold p-10 mb-32">
					市場、技術の変化を先取り、<br/>
					競争力ある技術、<br/>
					サービスを提供すること。<br/>
				</div>
				<hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
				<div className="italic text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold p-10 mb-32">
					優れた技術、自己開発を通じ、<br/>
					社会に貢献すること。<br/>
				</div>
				<hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
				<div className="italic text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold p-10">
					技術とサービスの融合を進め、<br/>
					新たなサービスを創出するIT企業を<br/>
					目指すこと。<br/>
				</div>
			</div>
		</div>

	)
}